import api from "../api";

export const getRealEstateAppraisalsAsync = (offerId) => {

  return api.get(`/real-estate-appraisal/offer/${offerId}`);

};
